<template>
  <div class="max-w-3xl mx-auto p-6">
    <div class="bg-white p-6 rounded shadow-md" data-testid="return-form-redirect">
      <p>Taking you to your return form…</p>
      <p class="mt-2">
        <a :href="target" class="text-blue-700 underline">Continue</a>
      </p>
    </div>
  </div>
</template>

<script>
export const RETURNS_SITE_URL = process.env.VUE_APP_RETURNS_SITE_URL || "https://customer-returns.netlify.app";

export function returnFormUrl(formToken) {
  const token = String(formToken || "").trim();
  return `${RETURNS_SITE_URL.replace(/\/+$/, "")}/returns/form/${encodeURIComponent(token)}`;
}

export default {
  name: "ReturnFormRedirect",
  props: {
    formToken: {
      type: String,
      default: "",
    },
  },
  computed: {
    target() {
      return returnFormUrl(this.formToken);
    },
  },
  mounted() {
    window.location.replace(this.target);
  },
};
</script>
